<template>
  <el-container v-title data-title="教职员考勤日报表" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
                <el-breadcrumb-item>教职员考勤日报表</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="教职员类型">
                  <el-select v-model="searchForm.facultyType" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="老师" value="1" v-if="userInfo.userType === '1' || userInfo.isFacultyAdmin != null && userInfo.isFacultyAdmin"></el-option>
                    <el-option label="教职工" value="2"></el-option>
                    <el-option label="其他" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="日期">
                  <el-date-picker
                    v-model="searchForm.date"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="loading" @click="getAttendenceStats">查询</el-button>
                  <el-button type="primary" :loading="isDownloading" @click="downloadStatFacultyAttendanceByDate">下载</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="userRealName" label="姓名" width="100"></el-table-column>
          <el-table-column prop="firstInTime" label="首次考勤时间" width="120">
            <template slot-scope="scope">
              <font :style="{color: schoolInfo.signInTimeForFaculty != null && timeFormater(scope.row.firstInTime) > schoolInfo.signInTimeForFaculty ? 'red' : 'black'}" type="text">{{ timeFormater(scope.row.firstInTime) }}</font>
            </template>
          </el-table-column>
          <el-table-column label="中途进出时间" width="300">
            <template slot-scope="scope">
              <span v-for="(attendanceInfo, index) in scope.row.attendanceInfoList" :key="index">{{attendanceInfo}} </span>
            </template>
          </el-table-column>
          <el-table-column prop="lastOutTime" label="末次考勤时间" width="120">
            <template slot-scope="scope">
              <font :style="{color: schoolInfo.signOutTimeForFaculty != null && timeFormater(scope.row.lastOutTime) < schoolInfo.signOutTimeForFaculty ? 'red' : 'black'}" type="text">{{ timeFormater(scope.row.lastOutTime) }}</font>
            </template>
          </el-table-column>
          <el-table-column v-if="searchForm.schoolId == 32" prop="goOutTimes" label="中途离校次数" width="120"></el-table-column>
        </el-table>
      </el-main>
      <el-dialog
        title="记录明细"
        :visible.sync="detailListDialogVisible"
        width="280px"
        :before-close="handleClose">
        <el-table :data="detailListTableData" border stripe>
          <el-table-column prop="deviceTypeName" label="考勤设备" width="120"></el-table-column>
          <el-table-column prop="insertTime" :formatter="insertTimeFormatter" label="时间" width="120"></el-table-column>
        </el-table>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      isDownloading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      searchForm: {
        schoolId: '',
        facultyType: '',
        date: ''
      },
      schoolList: [],
      schoolInfo: {},
      detailListDialogVisible: false,
      detailListTableData: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      if (this.Cookie.get('offsetSecond') !== undefined || this.Cookie.get('offsetSecond') !== '') {
        let now = Math.round(new Date().getTime() / 1000)
        now += parseInt(this.Cookie.get('offsetSecond'))
        this.searchForm.date = new Date(now * 1000).toISOString().split('T')[0]
      }
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getAttendenceStats()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getAttendenceStats () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/attendence/statFacultyAttendanceByDate',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          facultyType: _this.searchForm.facultyType,
          searchDate: _this.searchForm.date
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.tableData = res.data.data
            _this.schoolList.forEach(school => {
              if (_this.searchForm.schoolId != null && _this.searchForm.schoolId === school.id) {
                _this.schoolInfo = school
              }
            })
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getStatsDetailListForFaculty (row) {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/attendence/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          userId: row.userId,
          schoolId: _this.searchForm.schoolId,
          searchDate: _this.searchForm.date,
          page: 1,
          size: row.count
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.detailListDialogVisible = true
            _this.detailListTableData = res.data.data.list != null ? res.data.data.list : []
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    insertTimeFormatter (row) {
      return this.timeFormater(row.insertTime)
    },
    timeFormater (time) {
      return time != null && time.length === 19 ? time.substring(11) : time
    },
    downloadStatFacultyAttendanceByDate () {
      if (this.month === '') return
      let _this = this
      _this.isDownloading = true
      this.$axios.post(this.GLOBAL.host + '/attendence/downloadFacultyAttendanceByDate', this.$qs.stringify({
        schoolId: _this.searchForm.schoolId,
        facultyType: _this.searchForm.facultyType,
        searchDate: _this.searchForm.date
      }), {
        responseType: 'blob'
      }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
        _this.isDownloading = false
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/AttendenceStats.vue